// src/components/Sidebar/Sidebar.tsx
import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import { sidebarData } from "../sidebarData";
// import { sidebarData } from "./sidebarData";

const Sidebar: React.FC = () => {
  const location = useLocation();

  return (
    <aside className="w-64 h-screen bg-[#1E283F] text-white flex flex-col sticky top-0 z-50">
      <div className="p-6">
        <h2 className="text-2xl font-bold">Dashboard</h2>
      </div>
      <nav className="flex-1">
        <ul>
          {sidebarData.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`block p-4 hover:bg-gray-700 ${
                  location.pathname === item.path ? "bg-gray-700" : ""
                }`}
              >
                {/* {item.icon} */}
                <span className="ml-2">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
